import {ElLoading} from 'element-plus';
import {changeBlankLine} from "@/utils/TinyMCE";

export function registerCustomFontPlugin({onSetDefaultFont}) {
    tinymce.PluginManager.add('customfontfamily', function (editor) {
        const defaultFontStorageKey = 'tinymce-default-font-family';
        const fontItems = [
            {title: '微软雅黑', value: `"Microsoft YaHei", "Helvetica Neue", "PingFang SC", sans-serif`},
            {title: '宋体', value: `SimSun, 宋体, serif`},
            {title: '仿宋体', value: `FangSong, 仿宋, serif`},
            {title: '黑体', value: `SimHei, sans-serif`},
            {title: '楷体', value: `KaiTi, 楷体, STKaiti`},
            {title: 'Helvetica', value: `helvetica, sans-serif`},
            // {title: "sans-serif", value: `sans-serif`},
            {title: 'Arial Black', value: `"arial black", "avant garde"`},
            {title: 'Book Antiqua', value: `"book antiqua", palatino`},
            {title: 'Verdana', value: `verdana, geneva`},
            {title: 'Times New Roman', value: `"times new roman", serif`},
            {title: 'Calibri', value: `calibri, sans-serif`},
            {title: 'Century Gothic', value: `"century gothic", sans-serif`},
            {title: 'Comic Sans MS', value: `"comic sans ms", sans-serif`},
            {title: 'Arial', value: `arial`},
            {title: 'Tahoma', value: `tahoma`},
            {title: 'Courier New', value: `"courier new", courier, monospace`},
        ];

        const fontDisplayMap = Object.fromEntries(fontItems.map(i => [i.title, i.value.split(',')[0]]));

        let defaultFont = JSON.parse(localStorage.getItem("userInfo"))?.userFront ?? fontItems[0].value;
        console.log(defaultFont, 'JSON.parse(localStorage.getItem("userInfo"))?.userFront')
        let currentFont = "";

        function getFontItemByValue(value = '') {
            return fontItems.find(item => {
                const primary = item.value.split(',')[0].toLowerCase().trim();
                return value.toLowerCase().includes(primary);
            });
        }

        function renderLabel(item) {
            const isDefault = item.value === defaultFont;
            const isSelected = item.value === currentFont;
            let suffix = '';
            if (isSelected) suffix += ' ✔';
            if (isDefault) suffix += '（默认）';

            return {
                type: 'menuitem',
                text: item.title + suffix,
                classes: item.title,
                onAction: () => {
                    editor.formatter.apply('fontname', {value: item.value});
                    currentFont = item.value;
                    editor.ui.registry.getAll().buttons.customfontfamily?.update?.();
                },
                textStyle: `font-family: ${fontDisplayMap[item.title]}`
            };
        }

        editor.ui.registry.addMenuButton('customfontfamily', {
            type: 'menubutton',
            tooltip: '字体',
            text: '',
            classes: 'my-custom-font-button',
            fetch(callback) {
                const nodeFont = editor.dom.getStyle(editor.selection.getNode(), 'font-family', true) || '';
                currentFont = nodeFont;
                console.log('currentFont', currentFont)
                const items = fontItems.map(renderLabel);
                items.push({type: 'separator'});
                items.push({
                    type: 'menuitem',
                    text: '设置为默认字体',
                    onAction: async () => {
                        const nodeFont = editor.dom.getStyle(editor.selection.getNode(), 'font-family', true);
                        if (nodeFont) {
                            defaultFont = nodeFont;

                            // 显示 loading
                            const loading = ElLoading.service({
                                lock: true,
                                text: '正在设置默认字体...',
                                background: 'rgba(0, 0, 0, 0.3)'
                            });

                            try {
                                // 请求保存默认字体
                                if (onSetDefaultFont) {
                                    await onSetDefaultFont(defaultFont, editor);
                                }
                                // 本地缓存
                                localStorage.setItem(defaultFontStorageKey, defaultFont);

                                changeBlankLine(editor, defaultFont)
                                // 应用字体格式
                                editor.formatter.apply('fontname', {value: defaultFont});

                                // ✅ 强制刷新编辑器内容样式
                                const body = editor.getBody();
                                editor.dom.setStyle(body, 'font-family', defaultFont);

                                // ✅ 如果你有缓存的内容样式，也可以用这一步刷新全局内容
                                // editor.contentDocument.body.style.fontFamily = defaultFont;

                                // 刷新工具栏按钮
                                editor.ui.registry.getAll().buttons.customfontfamily?.update?.();

                            } catch (e) {
                                console.error('设置默认字体失败', e);
                            } finally {
                                loading.close();
                            }
                        }
                    }
                });
                callback(items);
            },
            onSetup(api) {
                const updateText = () => {
                    const nodeFont = editor.dom.getStyle(editor.selection.getNode(), 'font-family', true);
                    const item = getFontItemByValue(nodeFont);
                    if (item) {
                        api.setText(item.title);
                        api.setActive(true);
                    } else {
                        api.setText('字体');
                        api.setActive(false);
                    }
                };

                editor.on('NodeChange ExecCommand FormatApply FormatRemove', updateText);
                updateText();

                return () => {
                    editor.off('NodeChange ExecCommand FormatApply FormatRemove', updateText);
                };
            }
        });

        // 只在空段落时自动应用默认字体（保留你的原有逻辑）
        function ensureDefaultFontApplied() {
            if (!defaultFont) return;

            const node = editor.selection.getNode();
            if (!node || node.nodeType !== 1) return;

            let testNode = node;
            let hasFont = false;
            let isTemplateContent = false;

            while (testNode && testNode !== editor.getBody()) {
                const font = editor.dom.getStyle(testNode, 'font-family', true);
                if (font) hasFont = true;
                if (
                    testNode.classList?.contains('template-block') ||
                    testNode.getAttribute?.('data-template') === 'true'
                ) {
                    isTemplateContent = true;
                    break;
                }
                testNode = testNode.parentNode;
            }

            const text = node.textContent?.trim();
            const isEmpty = !text || text.length === 0;
            const isTag = ['P', 'DIV', 'SPAN'].includes(node.nodeName);

            if (!hasFont && isEmpty && !isTemplateContent && isTag) {
                setTimeout(() => {
                    editor.formatter.apply('fontname', {value: defaultFont});
                }, 0);
            }
        }

        editor.on('keydown', ensureDefaultFontApplied);
        editor.on('BeforeInput', ensureDefaultFontApplied);

        // 重写 getContent，给没有字体样式的块级元素加默认字体
        editor.on('PreInit', () => {
            const originalGetContent = editor.getContent.bind(editor);

            editor.getContent = function (args) {
                let content = originalGetContent(args);

                // 用 DOMParser 或容器解析
                const container = document.createElement('div');
                container.innerHTML = content;

                // 选择所有块级标签，这里以 p, div, span 为例，可以根据实际情况调整
                const blocks = container.querySelectorAll('p, div, span');

                blocks.forEach(node => {
                    // 检查是否已有 font-family 样式（内联样式或 style 里包含）
                    const style = node.getAttribute('style') || '';
                    const hasFontFamily = /font-family\s*:/i.test(style);
                    if (!hasFontFamily) {
                        // 直接追加内联样式，不覆盖已有样式
                        const newStyle = style.trim().endsWith(';') || style.trim() === ''
                            ? `${style} font-family: ${defaultFont};`
                            : `${style}; font-family: ${defaultFont};`;
                        node.setAttribute('style', newStyle.trim());
                    }
                });

                return container.innerHTML;
            };
        });

    });
};